var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#272D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3709 4.05L10.9772 5.64862C12.1944 6.07387 13.0905 6.71175 12.9156 7.893C12.8649 8.25187 12.7412 8.61131 12.4858 8.883C12.267 9.11756 11.925 9.24188 11.6331 9.3375C11.283 9.45591 10.9169 9.52021 10.5474 9.52819C10.2999 9.52819 10.0592 9.52087 9.81169 9.49894C9.41119 9.46912 9.00281 9.43256 8.60962 9.34481C8.48587 9.31556 8.36888 9.29362 8.25975 9.26381L7.72762 11.4126L7.41431 12.5859L7.02056 14.1924L6.05194 13.9506L6.453 12.3294C6.22688 12.2709 5.99344 12.2051 5.76056 12.1461L4.5 11.8311L4.98094 10.7229C4.98094 10.7229 5.69531 10.9142 5.68744 10.8996C5.96475 10.9654 6.08119 10.782 6.13181 10.665L6.67856 8.4645L6.93338 7.44525L7.22531 6.27187C7.23938 6.06656 7.16681 5.80275 6.77306 5.70712C6.78769 5.69981 6.06656 5.53106 6.06656 5.53106L6.32137 4.48987L7.6545 4.82737C7.85925 4.878 8.06288 4.92244 8.27437 4.97362L8.66813 3.375L9.63675 3.61687L9.25087 5.18625C9.50569 5.24531 9.76837 5.30381 10.0232 5.36962L10.4018 3.80756L11.3709 4.05ZM11.2911 9.84375C11.5605 9.79931 11.8884 9.68962 12.1213 9.594C12.1286 9.58669 12.1438 9.58669 12.1506 9.57938C12.6534 10.0266 12.8936 10.7527 12.5657 11.6842C12.0482 13.1951 10.8028 13.3194 9.15581 13.0044L8.75531 14.625L7.79344 14.3831L8.16469 12.8357L8.17931 12.7845L8.47125 11.5959C9.33075 11.7872 10.4895 11.9115 10.7077 11.0166C10.8247 10.5401 10.5986 10.1953 10.2341 9.94612L10.6132 9.92362C10.8833 9.90956 11.0211 9.88819 11.2911 9.84375ZM11.0064 7.87781C11.2911 6.72638 9.52706 6.47719 8.98144 6.33094L8.49994 8.28113C9.04669 8.42063 10.737 8.97806 11.0064 7.87781Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcp);
export default __webpack_public_path__ + "static/media/btcp.9570ebd8ef523ba3dd2a1c52b5cfcc96.svg";
export { ForwardRef as ReactComponent };